export default {
  BODY: "body",
  BODY_LF: "bodyLongForm",
  CAPS: "caps",
  CAPTION: "caption",
  SECONDARY_SM: "secondarySmall"
};
